import COMMON_TYPES from '../../../actions/types';
import * as analytics from '../../../analytics';

import { details } from '../../../api/common';
import { createProgress, deleteProgress } from '../../../api/service';
import { showNotificationLayer } from '../../../actions/notification';
import { formatFormComment } from '../utils';

const loadingPostManager = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const deleteComment = params => {
  return dispatch => {
    dispatch(loadingPostManager());

    deleteProgress(params.formParams)
      .then(() => { dispatch(loadingPostManager()); })
      .catch(responseFail => {
        dispatch(loadingPostManager());

        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data,
        });
      })
  }
}

export const createComment = params => {
  return dispatch => {
    dispatch(loadingPostManager());

    createProgress(params.formParams)
      .then(response => {
        dispatch(loadingPostManager());
        dispatch(toggleFormCommentLayer());

        dispatch(
          showNotificationLayer(`Comentário incluido no atendimento ${response.data.reference}!`)
        )
      })
      .catch(responseFail => {
        dispatch(loadingPostManager());

        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data,
        });
      })
  }
}

export const toggleFormCommentLayer = params => {
  if(params && params.id) {
    analytics.registerEvent({
      category: analytics.categories.service,
      action: analytics.actions.serviceComment,
    });

    return dispatch => {
      dispatch([
        {
          type: COMMON_TYPES.toggleLayer,
          payload: 'createComment',
        },
        { type: COMMON_TYPES.formGetWatingResponse, payload: true },
      ]);

      details({ id: params.id, path: 'atendimento.php' })
        .then(({ data }) => {
          dispatch([{
              type: COMMON_TYPES.formInitializeValues,
              payload: formatFormComment(data),
            },
            { type: COMMON_TYPES.formGetWatingResponse, payload: false },
          ])
        })
        .catch((e) =>
          dispatch({ type: COMMON_TYPES.formGetResultError })
        )
    }
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
